import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class RouterService {

  constructor(private router: Router, private route: ActivatedRoute) { }

  goto(route: string, extras?: NavigationExtras): void {
    this.router.navigate([route], extras);
  }

  getQueryParam(param: string): string {
    return this.route.snapshot.queryParams[param];
  }

  navigateWithQuery(route: string,params:{[key: string]: string}) {
    this.router.navigate([route],{queryParams:params});
  }

  openInNewTab(route: string, extras?: NavigationExtras): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([route], extras)
    );
    window.open(url, '_blank');
  }
}
